import { DEPOSIT_INFORMATION_TEXT } from 'constants/paymentMethods';

export const getVerificationFormInfoText = () =>
  `Please enter the two small amounts we deposited into your bank account. ${DEPOSIT_INFORMATION_TEXT}`;
